// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "application." + "75e30f36d1138c2cce14" + ".css";
};